import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import {
  UPDATE_FIELD_USER,
  USER_CREATE,
  USER_CREATE_UNLOADED
} from '../constants/actionTypes';
import Dropdown from 'react-dropdown'
import { Countries } from '../constants/config'

const mapStateToProps = state => ({ ...state.user, countries: state.common.countries, });

const mapDispatchToProps = dispatch => ({
  onChangeEmail: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'email', value }),
  onChangePassword: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'password', value }),
  onChangePhone: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'phone', value }),
  onChangeFirstname: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'firstname', value }),
  onChangeLastname: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'lastname', value }),
  onChangePin: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'pin', value }),
  onChangeCountryCode: value =>
    dispatch({ type: UPDATE_FIELD_USER, key: 'countrycode', value }),
  onSubmit: (email, password, firstname, lastname, phone, pin, countrycode) => {
    const payload = agent.Users.create(email, password, firstname, lastname, phone, pin, countrycode || 'za');
    dispatch({ type: USER_CREATE, payload })
  },
  onUnload: () =>
    dispatch({ type: USER_CREATE_UNLOADED })
});

class UserAdd extends React.Component {
  constructor() {
    super();
    this.changeEmail = ev => this.props.onChangeEmail(ev.target.value)
    this.changePassword = ev => this.props.onChangePassword(ev.target.value)
    this.changePhone = ev => this.props.onChangePhone(ev.target.value)
    this.changeFirstname = ev => this.props.onChangeFirstname(ev.target.value)
    this.changeLastname = ev => this.props.onChangeLastname(ev.target.value)
    this.changePin = ev => this.props.onChangePin(ev.target.value)
    this.changeCountryCode = (countrycode) => this.props.onChangeCountryCode(countrycode)
    this.submitForm = (email, password, firstname, lastname, phone, pin, countrycode) => ev => {
      ev.preventDefault();
      this.props.onSubmit(email, password, firstname, lastname, phone, pin, countrycode);
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  // onSelectCountry(option) {
  //   this.changeCountryCode(option.value)
  // }
  render() {
    const email = this.props.email;
    const password = this.props.password;
    const firstname = this.props.firstname;
    const lastname = this.props.lastname;
    const phone = this.props.phone;
    const pin = this.props.pin
    const countries = this.props.countries || Countries
    const countryOptions = countries.map(i => { return { value: i.iso2, label: i.name } })
    const countrycode = this.props.countrycode || 'za'
    return (
      <div class='pane'>
        <Link className="crumb" to="/users">&laquo; back to users</Link>
        <h1>Create User</h1>
        <ListErrors errors={this.props.errors} />
        <form onSubmit={this.submitForm(email, password, firstname, lastname, phone, pin, countrycode)}>
          <fieldset className="form">
            <fieldset className="form-group">
              <div style={{ maxWidth: '300px' }}><Dropdown options={countryOptions} onChange={(option) => this.changeCountryCode(option.value)} value={countrycode} /></div>
            </fieldset>
            <fieldset className="form-group">
              <input
                type="text"
                placeholder="First name"
                value={firstname}
                onChange={this.changeFirstname} />
            </fieldset>
            <fieldset className="form-group">
              <input
                type="text"
                placeholder="Last name"
                value={lastname}
                onChange={this.changeLastname} />
            </fieldset>
            <fieldset className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={this.changeEmail} />
            </fieldset>

            <fieldset className="form-group">
              <input
                type="text"
                placeholder="Phone"
                value={phone}
                onChange={this.changePhone} />
            </fieldset>

            <fieldset className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={this.changePassword} />
            </fieldset>
            <fieldset className="form-group">
              <input
                type="password"
                placeholder="Pin"
                value={pin}
                maxLength={4}
                onChange={this.changePin} />
            </fieldset>

            <fieldset className="form-group">
              <button
                type="submit"
                disabled={this.props.inProgress}>
                Create User
              </button>
            </fieldset>
          </fieldset>
        </form>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdd);



// WEBPACK FOOTER //
// ./src/components/UserAdd.js